module.exports = __webpack_public_path__ + "static/img/step-072.e2f2584.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/tutorial/sery/step-072.png
// module id = JueJ
// module chunks = 1